export default __webpack_public_path__ + "static/cindy-engelhardt-f50676a424b3ad7a0cf5c18c016ae1c9.webp";